import { DateTime } from 'luxon'

export const formatDateToString = (date: string, addYearAlways = false) => {
  const dateObject = DateTime.fromISO(date)

  if (!addYearAlways && dateObject.year === DateTime.now().year) {
    return dateObject.toFormat('dd.MM')
  }

  return dateObject.toFormat('dd.MM.yyyy')
}
